import React, { useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Utils from "../../../utility";
import { activeUserService } from "../../../services/index";
import Loader from "../../../common/components/tablesLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 890,
    overflow: "auto",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "&::-webkit-scrollbar-track": {
      display: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      display: "none",
    },
  },
  Card: {
    maxHeight: 20,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },

  link: {
    "& > * + *": {
      marginLeft: theme.spacing(51),
    },
  },
  Table: {
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "red",
    },
  },
  selectDropdown: { color: "#fff", backgroundColor: "#1b1f38" },
}));

const WebView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 959px) {
    display: none;
  }
  @media (min-width: 960px) {
    display: visible;
  }
`;

const TabView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 959px) {
    display: visible;
  }
  @media (min-width: 960px) {
    display: none;
  }
`;

export default function StickyHeadTable(props) {
  const preventDefault = (event) => event.preventDefault();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  return (
    <Paper elevation={0} className={classes.root}>
      <Card className={classes.Card}>
        <Typography
          className={classes.link}
          variant="h8"
          color="#001441"
        ></Typography>
      </Card>
      <TableContainer className={classes.container} id="category_scroll">
        <WebView>
          <Table className={classes.Table}>
            <TableHead className="table-body">
              <TableRow>
                <TableCell align="left" id="Table-cell-active"></TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  User Name
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  User ID
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Videos Created
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Sold
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Purchased
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Views
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Likes
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Revenue (XDC) 
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {props?.isLoading ? (
                <TableRow>
                  <TableCell style={{ border: "none" }} colspan={12}>
                    <div className="homePageLoader">
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                props.activeUser &&
                props.activeUser.length >= 1 &&
                props.activeUser
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index} className="table-row">
                      <TableCell align="left" className="Table-cell">
                        <img
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: "15px",
                          }}
                          src={row.profilePicUrl || "/defaultprofile.png"}
                          alt=""
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell w-0 padding-tab"
                      >
                        {row.firstName || "-"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row._id || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalVideosCreated || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalSold || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalPurchased || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalViews || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalLikes || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.earnings || "0"}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </WebView>

        <TabView>
          <Table className={classes.Table}>
            <TableHead className="table-body">
              <TableRow>
                <TableCell align="left" id="Table-cell-active"></TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  User Name
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  User ID 
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Videos Created
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Sold
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Purchased
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Views
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Likes
                </TableCell>
                <TableCell
                  align="left"
                  id="Table-cell-active"
                  className="padding-tab"
                >
                  Revenue (XDC)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {props?.isLoading ? (
                <TableRow>
                  <TableCell style={{ border: "none" }} colspan={5}>
                    <div className="homePageLoader">
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                props.tabActiveUser &&
                props.tabActiveUser.length >= 1 &&
                props.tabActiveUser
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow className="table-row">
                      <TableCell align="left" className="Table-cell">
                        <img
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: "15px",
                          }}
                          src={row.profilePicUrl || "/defaultprofile.png"}
                          alt=""
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell w-0 padding-tab"
                      >
                        {row.firstName || "undefined"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row._id || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalVideosCreated || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalSold || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalPurchased || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalViews || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.totalLikes || "0"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className="Table-cell padding-tab"
                      >
                        {row.earnings || "0"}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TabView>
      </TableContainer>
      <TablePagination
        id="test"
        classes={{
          selectIcon: classes.select,
          paper: classes.selectDropdown,
          caption: classes.tablePaginationCaption,
        }}
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={props.activeUser.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
